export default __webpack_public_path__ + "static/media/2054.98433841.png";